/*
* Method to handle start display of the loading spinner
* */
export function startLoadingSpinner() {

  window.scrollTo({
    top: 0, behavior: 'smooth' // Optional, for smooth scrolling
  });

  // spinner markup is already in pages
  const background = document.querySelectorAll(".ui-loader-background");
  const loader = document.querySelectorAll("#loader");

  if (background !== undefined && background !== null) {
    if (loader !== undefined && loader !== null) {
      if (background.length > 1 || loader.length > 1) {
        background[1].style.display = 'block';
        loader[1].style.visibility = 'visible';
      } else {
        background[0].style.display = 'block';
        loader[0].style.visibility = 'visible';
      }
    }
  }
}

export function startLoadingSpinnerNoScroll() {
    // spinner markup is already in pages
  const background = document.querySelectorAll(".ui-loader-background");
  const loader = document.querySelectorAll("#loader");

  if (background !== undefined && background !== null) {
    if (loader !== undefined && loader !== null) {
      if (background.length > 1 || loader.length > 1) {
        background[1].style.display = 'block';
        loader[1].style.visibility = 'visible';
      } else {
        background[0].style.display = 'block';
        loader[0].style.visibility = 'visible';
      }
    }
  }
}

/*
* Method to handle stop display of the loading spinner
* */
export function stopLoadingSpinner() {
  // spinner markup is already in pages
  const background = document.querySelectorAll(".ui-loader-background");
  const loader = document.querySelectorAll("#loader");

  if (background !== undefined && background !== null) {
    if (loader !== undefined && loader !== null) {
      if (background.length > 1 || loader.length > 1) {
        background[1].style.display = 'none';
        loader[1].style.visibility = 'hidden';
      } else {
        background[0].style.display = 'none';
        loader[0].style.visibility = 'hidden';
      }
    }
  }
}
